export const patents = [
  {
    id: '10-2024-0001234',
    title: 'AI 기반 에너지 수요 예측 시스템 및 그 방법',
    category: 'AI Energy Platform',
    type: '출원',
    date: '2024.01.15',
    status: '심사중',
  },
  {
    id: '10-2024-0005678',
    title: '디지털 트윈 기반 전력망 실시간 모니터링 장치',
    category: 'Digital Twin',
    type: '출원',
    date: '2024.03.22',
    status: '심사중',
  },
  {
    id: '10-2023-0098765',
    title: '분산형 재생에너지 네트워크 제어 방법',
    category: 'Distributed Energy',
    type: '등록',
    date: '2023.08.10',
    status: '등록완료',
  },
  {
    id: '10-2023-0054321',
    title: '스마트그리드 최적화 알고리즘',
    category: 'Smart Grid',
    type: '출원',
    date: '2023.05.18',
    status: '심사중',
  },
  {
    id: '10-2023-0023456',
    title: '에너지 효율화를 위한 머신러닝 기반 예측 모델',
    category: 'AI Energy Platform',
    type: '등록',
    date: '2023.02.28',
    status: '등록완료',
  },
  {
    id: '10-2024-0011122',
    title: 'PCT: 국제 에너지 데이터 통합 플랫폼',
    category: 'AI Energy Platform',
    type: 'PCT출원',
    date: '2024.06.05',
    status: '국제심사',
  },
];

export const patentCategories = [
  { name: 'AI Energy Platform', count: 3, color: '#22D3EE' },
  { name: 'Digital Twin', count: 1, color: '#34D399' },
  { name: 'Smart Grid', count: 1, color: '#22D3EE' },
  { name: 'Distributed Energy', count: 1, color: '#34D399' },
];

export const pctStrategy = [
  {
    country: '미국 (USPTO)',
    desc: 'AI Energy Platform 및 Smart Grid 관련 핵심 기술의 미국 특허 출원',
    status: '진행중',
  },
  {
    country: '유럽 (EPO)',
    desc: 'Digital Twin 기반 에너지 모니터링 기술의 유럽 출원 전략 수립',
    status: '계획',
  },
  {
    country: '중국 (CNIPA)',
    desc: '분산형 재생에너지 네트워크 제어 기술의 중국 출원 준비',
    status: '준비중',
  },
];